import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectieSelectionDialogComponent } from './directie-selection-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        DirectieSelectionDialogComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [DirectieSelectionDialogComponent],
})
export class DirectieSelectionDialogModule { }
